import styled, { css } from 'styled-components'

import { media } from '@/theme/common'

export const List = styled.div(
  ({ theme }) => css`
    overflow: hidden;
    border: ${theme.border.size['1']} solid ${theme.colors.gray400};
    border-radius: ${theme.border.radius['6']};
    background-color: ${theme.colors.white};
  `,
)

export const Row = styled.div(
  ({ theme }) => css`
    display: grid;
    grid-template-columns: 1fr;
    align-items: center;
    gap: ${theme.space['4']};
    min-height: 4.8rem;
    padding: ${theme.space['6']} ${theme.space['16']};
    border-bottom: ${theme.border.size['1']} solid ${theme.colors.gray400};

    &:last-child {
      border-bottom: none;
    }

    ${media.up('md')} {
      grid-template-columns: 20rem minmax(0, 1fr);
      gap: ${theme.space['24']};
    }
  `,
)

export const LabelWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.space['6']};
    min-width: 0;
  `,
)

export const PmsIconWrapper = styled.span(
  ({ theme }) => css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 2.4rem;
    height: 2.4rem;
    border-radius: ${theme.border.radius.circle};
    background-color: ${theme.colors.blue100};
    color: ${theme.colors.blue500};
    cursor: help;
  `,
)

export const Value = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: ${theme.space['8']};
    color: ${theme.colors.primary800};
    font-size: 1.4rem;
    line-height: 2rem;
  `,
)
